
export const ALLOWABLE_COLLECTIONS: TemplateType[] = ["Messages", "Comments", "Rejections"];

export type TemplateType = "Messages" | "Comments" | "Rejections";
